import {Injectable} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {environment} from '../../../environments/environment';
import {COMMON} from '../../shared/contstants/common.const';
import {PERMISSIONS} from "../../shared/contstants/permissions.const";
import {Title} from "@angular/platform-browser";
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class StorageUtilsService {

    private _changeSiteSection: BehaviorSubject<boolean | null>;
    siteSection = COMMON.SITE_SECTION;

    /**
     * Constructor
     */
    constructor(private _cookieService: CookieService,
                private _titleService: Title) {

        this._changeSiteSection = new BehaviorSubject(false);
    }

    get changeSiteSection$(): any {
        return this._changeSiteSection.asObservable();
    }

    urlDependingSection(val?: any): string | null {
        const section = this.getSection();
        if (!section) {
            return null;
        }
        let url = '';
        switch (true) {
            case section === COMMON.SITE_SECTION_CUSTOMER: {
                url = this.urlDependingValue();
                break;
            }
            case section === COMMON.SITE_SECTION_AGENT: {
                url = this.urlDependingValue(val);
                break;
            }
            case section === COMMON.SITE_SECTION_CONTROL: {
                url = this.urlDependingValue(val + 1);
                break;
            }
            case section === COMMON.SITE_SECTION_BACKEND: {
                url = this.urlDependingValue(val + 1);
                break;
            }
            default : {
                url = this.urlEmpty();
                break;
            }
        }
        return url;
    }

    urlDependingValue(val?: any): string {
        let url = '';
        switch (true) {
            case val === 1: {
                url = this.urlSection();
                break;
            }
            case val === 2: {
                url = this.urlWithOrganization();
                break;
            }
            case val === 3: {
                url = this.urlWithSite();
                break;
            }
            case val === 4: {
                url = this.urlWithOrganizationAndSites();
                break;
            }
            default : {
                url = this.urlEmpty();
                break;
            }
        }
        return url;
    }

    urlEmpty(): string {
        return environment.apiUrl;
    }

    urlSection(): string {
        return environment.apiUrlSection;
    }

    urlWithSite(): string {
        return `${environment.apiUrlSection}/sites/${this.get('siteId')}`;
    }

    urlWithOrganization(): string {
        return `${environment.apiUrlSection}/organizations/${this.get('organizationId')}`;
    }

    urlWithOrganizationAndSites(): string {
        return `${environment.apiUrlSection}/organizations/${this.get('organizationId')}/sites/${this.get('siteId')}`;
    }

    clear(): void {
        this._cookieService.deleteAll();
    }

    check(field): any {
        return this._cookieService.check(COMMON.COOKIE_KEY + field);
    }

    set(field: string, data: any): void {
        this._cookieService.set(COMMON.COOKIE_KEY + field, JSON.stringify(data), null, '/');
    }

    get(field: string): any {
        return JSON.parse(this._cookieService.get(COMMON.COOKIE_KEY + field));
    }

    // SECTION SITE

    setSection(section: string): void {
        this._changeSiteSection.next(true);
        environment.apiUrlSection = environment.apiUrl + '/' + section;
        sessionStorage['section'] = section;
    }

    resetSection(): void {
        const sections = this.siteSection;
        sections.map(section => {
            if (sessionStorage[section]) {
                delete sessionStorage[section];
            }
        });
    }

    getSection(): string {
        return sessionStorage['section'];
    }

    // CONFIG SITE

    setConfig(data: any): void {
        sessionStorage['config'] = JSON.stringify(data);
        this.checkConfig();
    }

    checkConfig(): void {
        const config = this.config;
        if (config && config.data && config.data.favicon) {

            const favIcon = document.getElementById('appIcon') || document.createElement('link');
            favIcon['type'] = 'image/x-icon';
            favIcon['rel'] = 'shortcut icon';
            favIcon['href'] = 'https://quickstorage.net/dlucky/YpJElL58o9fPGY626WYOAZhXiCBYOrMKXLduf6XC.ico';
            // document.getElementsByTagName('head')[0].appendChild(this.favIcon);
            // console.log(favIcon['href']);
        }
        if (config && config.name) {

            environment.currentSiteName = config.name;
            this._titleService.setTitle(config.name);
        }
    }

    getLogo(): string {
        if (this.config && this.config.data) {
            return this.config.data.logo || COMMON.LOGO_PATCH;
        }
        return COMMON.LOGO_PATCH;
    }

    resetConfig(): void {
        delete sessionStorage['config'];
    }

    get config(): any {
        if (sessionStorage['config']) {
            return JSON.parse(sessionStorage['config']);
        }
    }

    // checkSections(url: string): void {
    //     const sections = this.siteSection;
    //     let splitUrls = url.split('/');
    //
    //     // удаление пустых елементов
    //     splitUrls = splitUrls.filter(val => val);
    //
    //     const section = splitUrls[0];
    //     const isSection = sections.includes(section);
    //     if (isSection) {
    //         this.setSection(section);
    //         environment.apiUrlSection = environment.apiUrl + section + '/';
    //     }
    // }
}

